import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";

import Sortable from "../../../../componets/Sortable";
import { reorderAssets } from "../../../../actions/mine_craft/assetsActions";

const Reorder = () => {
  const dispatch = useAppDispatch();
  const reorderIds = useAppSelector(state => state.mineCraft.assets.reorderIds);
  const assets = useAppSelector(state => state.mineCraft.assets.entities);

  function onClickSave(ids: any[]) {
    dispatch(reorderAssets({ ids }));
  }

  return (
    <div className='v-assets-reorder'>
      <h6 className="v-content-label o-sm">Reorder</h6>

      {
        reorderIds &&
          <Sortable
            ids={reorderIds}
            onClickSave={onClickSave}
            imageKey={'image_url'}
            items={assets}
            titleKey='name'
          />
      }
    </div>
  )
}

export default Reorder;
